import firebase from "firebase";

const Config = firebase.initializeApp({
  apiKey: "AIzaSyBmML5GIjxbXjtLRfVIdm2CL_YKwVy1dgo",
  authDomain: "ssaw-members.firebaseapp.com",
  databaseURL: "https://ssaw-members.firebaseio.com",
  projectId: "ssaw-members",
  storageBucket: "ssaw-members.appspot.com",
  messagingSenderId: "738279169798",
  appId: "1:738279169798:web:52cdb64c9de956abf58887",
});

export const db = Config.firestore();

export default Config;

//timestamp: Firebase.firestore.FieldValue.serverTimestamp(),
